export default "__VITE_ASSET__432de8a0__"